// Accordion icons
$('.wp-block-create-block-accordion-heading button').prepend('<i class="fas fa-plus icon-collapsed"></i><i class="fas fa-minus icon-expanded"></i>');
